export const API_ACTIONS = {
	SUCCESS: '_SUCCESS',
	ERROR: '_ERROR',
	PENDING: '_PENDING',
	ABORTED: '_ABORTED',
};
